import React from "react";
import { Button, ButtonProps, Box } from "@chakra-ui/react";

interface GradientButtonProps extends Omit<ButtonProps, "bgGradient"> {
  showArrow?: boolean;
  bgGradient?: string;
}

const GradientButton: React.FC<GradientButtonProps> = ({
  showArrow = true,
  bgGradient = "linear-gradient(135deg, #38BBD1, #3EEAEC)",
  children,
  px = "20px",
  py = "10px",
  ...props
}) => {
  const basePadding = typeof px === "string" ? px : "20px";
  // Don't show arrow if rightIcon is provided (user wants to use their own icon)
  const shouldShowArrow = showArrow && !props.rightIcon;
  
  return (
    <Button
      bgGradient={bgGradient}
      color="white"
      fontWeight="medium"
      borderRadius="8px"
      px={px}
      py={py}
      h="auto"
      fontFamily="'IBM Plex Sans', sans-serif"
      textTransform="uppercase"
      fontSize="sm"
      display="inline-flex"
      alignItems="center"
      transition="all 0.3s ease"
      _hover={{
        pr: shouldShowArrow ? `calc(${basePadding} + 0.5rem)` : undefined,
      }}
      _active={{
        bgGradient: bgGradient,
      }}
      sx={{
        "& .button-arrow": {
          width: "1.25rem",
          height: "1.25rem",
          transition: "transform 0.3s ease",
          color: "white",
        },
        "&:hover .button-arrow": {
          transform: shouldShowArrow ? "translateX(6px)" : undefined,
        },
      }}
      {...props}
    >
      {children}
      {shouldShowArrow && (
        <Box
          as="svg"
          className="button-arrow"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          w="1.25rem"
          h="1.25rem"
          color="white"
        >
          <path
            fillRule="evenodd"
            d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </Box>
      )}
    </Button>
  );
};

export default GradientButton;
